import React from 'react';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none rounded-md uppercase tracking-wide';
  const variants = {
    primary: 'bg-[#ff9900] hover:bg-[#e68a00] text-white shadow-[0_4px_0_rgb(180,100,0)] active:shadow-none active:translate-y-[4px] focus:ring-orange-500',
    secondary: 'bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl focus:ring-red-500',
    outline: 'border-2 border-gray-300 bg-transparent hover:bg-gray-50 text-gray-700 focus:ring-gray-400'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg',
    xl: 'h-16 px-10 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={cn(baseStyles, variants[variant], sizes[size], widthClass, className)} {...props} data-id="element-17">
      {children}
    </button>;
}